import { useQuery } from 'react-query';
import { IMappedSurveyResponse, ISurveyResponse } from '@interfaces/SurveyLookups.interface';
import { survey } from '@services/Survey/Survey';

export function useGetSurveyLookups(requestId: string) {
  return useQuery(
    ['SurveyLookups'],
    async () => {
      const { data: authData } = await survey.getAccessToken();
      const { data } = await survey.getSurveyLookups(requestId, authData.access_token);
      return mapLookupData(data);
    },
    {
      refetchOnMount: false,
      staleTime: 100000,
      cacheTime: 100000,
      refetchOnWindowFocus: false,
      retry: false,
    }
  );
}

const mapLookupData = (data: ISurveyResponse): IMappedSurveyResponse => {
  return {
    id: data.id,
    serviceName: data.serviceName,
    requestId: data.requestId,
    status: data.status,
    EASE_OF_USE: data.lookup.EASE_OF_USE
      ? data.lookup.EASE_OF_USE.map(({ key, value, valueAr, id }) => ({
          label: value,
          labelAr: valueAr,
          value: key,
          id,
        }))
      : [],
    SATISFACTION_LEVEL: data.lookup.SATISFACTION_LEVEL
      ? data.lookup.SATISFACTION_LEVEL.map(({ key, value, valueAr, id }) => ({
          label: value,
          labelAr: valueAr,
          value: key,
          id,
        }))
      : [],
    ANY_ISSUE: data.lookup.ANY_ISSUE
      ? data.lookup.ANY_ISSUE.map(({ key, value, valueAr, id }) => ({
          label: value,
          labelAr: valueAr,
          value: key,
          id,
        }))
      : [],
  };
};
